import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StaticService {
  private readonly staticUrl = `${environment.BASE_URL}${environment.BASE_API.STATIC}`;

  constructor(private http: HttpClient) {}

  getScreensMap(): Observable<Record<string, string>> {
    return this.http.get<any>(this.staticUrl).pipe(
      map((resp) => (resp?.body?.SCREENS ?? {}) as Record<string, string>),
      tap((mapObj) => sessionStorage.setItem('SCREENS', JSON.stringify(mapObj)))
    );
  }
}


